import React from 'react'
import Helmet from 'react-helmet'

import { FOOD_BOX_PAGE, PageRenderer, useCmsBlock } from '@library/cms-blocks'
import type { CmsCtaIntentHandlers, CmsFetcher } from '@library/cms-blocks'

import { HowGoustoFoodBoxesWorkTypes } from '../../types'
import { TargetUri } from '../../types/tracking'
import { SEO } from '../FoodBoxPage/config'

type Props = HowGoustoFoodBoxesWorkTypes & {
  cmsFetcher: CmsFetcher
}

export function FoodBoxCmsPage({ cmsFetcher, startOnboarding }: Props) {
  const { data } = useCmsBlock(FOOD_BOX_PAGE, cmsFetcher)
  const createOnboardingHandler =
    (targetUri: TargetUri): React.MouseEventHandler<HTMLElement> =>
    (event) => {
      event.preventDefault()
      startOnboarding(targetUri)
    }

  const ctaIntentHandlers: CmsCtaIntentHandlers = {
    start_onboarding_wizard: {
      href: TargetUri.SIGNUP,
      onClick: createOnboardingHandler(TargetUri.SIGNUP),
    },
    start_onboarding_menu: {
      href: TargetUri.MENU,
      onClick: createOnboardingHandler(TargetUri.MENU),
    },
  }

  return (
    <div data-testid="food-box-cms-page">
      <Helmet title={SEO.head.title} meta={SEO.head.meta}>
        <meta property="og:title" content={SEO.head.title} />
        <meta property="og:description" content={SEO.head.meta[0]?.content || ''} />
      </Helmet>
      {data ? <PageRenderer page={data} ctaIntentHandlers={ctaIntentHandlers} /> : null}
    </div>
  )
}
